import { render, staticRenderFns } from "./PostRepairConfirmations.vue?vue&type=template&id=5a0558b7&scoped=true"
import script from "./PostRepairConfirmations.vue?vue&type=script&lang=js"
export * from "./PostRepairConfirmations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0558b7",
  null
  
)

export default component.exports